<template>
  <div class="h-full w-full overflow-y-auto text-app-color">
    <div class="max-w-300 mx-auto md:mx-0 md:max-w-full md:pl-100 py-35 md:pt-67 text-app-color">
      <div class="flex items-center md:hidden" @click="back">
        <i class="text-12 mr-10 icon-keyboard-arrow-left opacity-50" />
        <p class="text-opacity-80">Back</p>
      </div>

      <p class="text-30 md:text-21 font-bold">Keyboard shortcuts</p>
      <div class="mt-30">
        <p class="text-16 font-bold">Hello Ivy specific</p>
        <div class="md:flex text-14 w-full">
          <div class="w-300 md:pr-50">
            <div class="flex justify-between my-5"><p :class="isDarkMode? 'text-app-color' : 'text-dark-500'">Create checkbox</p>         <p>[]</p></div>
            <div class="flex justify-between my-5"><p :class="isDarkMode? 'text-app-color' : 'text-dark-500'">Internal linking</p>        <p>@</p></div>
            <div class="flex justify-between my-5"><p :class="isDarkMode? 'text-app-color' : 'text-dark-500'">Emoticon</p>                <p>:</p></div>
            <div class="flex justify-between my-5"><p :class="isDarkMode? 'text-app-color' : 'text-dark-500'">Blockquote</p>              <p>></p></div>
            <div class="flex justify-between my-5"><p :class="isDarkMode? 'text-app-color' : 'text-dark-500'">Switch dark/light mode</p>  <p>ctrl + ?</p></div>
            <div class="flex justify-between my-5"><p :class="isDarkMode? 'text-app-color' : 'text-dark-500'">Open shortcut menu </p>     <p>ctrl + 0</p></div>
            <div class="flex justify-between my-5"><p :class="isDarkMode? 'text-app-color' : 'text-dark-500'">Close settings menu </p>    <p>ESC</p></div>
            <div class="flex justify-between my-5"><p :class="isDarkMode? 'text-app-color' : 'text-dark-500'">Focus on search input </p>    <p>ctrl + k</p></div>
          </div>

          <div class="hidden md:block w-300 md:pl-50">
            <div class="flex justify-between my-5"><p :class="isDarkMode? 'text-app-color' : 'text-dark-500'">Divider</p>                 <p>---</p></div>
            <div class="flex justify-between my-5"><p :class="isDarkMode? 'text-app-color' : 'text-dark-500'">H1</p>                      <p>#</p></div>
            <div class="flex justify-between my-5"><p :class="isDarkMode? 'text-app-color' : 'text-dark-500'">H2</p>                      <p>##</p></div>
            <div class="flex justify-between my-5"><p :class="isDarkMode? 'text-app-color' : 'text-dark-500'">H3</p>                      <p>###</p></div>
          </div>
        </div>
      </div>

      <div class="mt-30">
        <p class="text-16 font-bold">The ones you probably know</p>
        <div class="md:flex text-14 w-full">
          <div class="w-300 md:pr-50 md:pb-20">
            <div class="flex justify-between my-5"><p :class="isDarkMode? 'text-app-color' : 'text-dark-500'">Bold</p>                    <p>ctrl + b</p></div>
            <div class="flex justify-between my-5"><p :class="isDarkMode? 'text-app-color' : 'text-dark-500'">Italic</p>                  <p>ctrl + i</p></div>
            <div class="flex justify-between my-5"><p :class="isDarkMode? 'text-app-color' : 'text-dark-500'">Underline</p>               <p />ctrl + u</div>
            <div class="flex justify-between mb-5"><p :class="isDarkMode? 'text-app-color' : 'text-dark-500'">Strike through</p>          <p />ctrl + d</div>
            <div class="flex justify-between my-5"><p :class="isDarkMode? 'text-app-color' : 'text-dark-500'">Step back</p>               <p />ctrl + z</div>
            <div class="flex justify-between my-5"><p :class="isDarkMode? 'text-app-color' : 'text-dark-500'">Step forward</p>            <p />ctrl + y</div>
            <div class="flex justify-between my-5"><p :class="isDarkMode? 'text-app-color' : 'text-dark-500'">Unordered list</p>          <p>-</p></div>
          </div>
          <div class="w-300 md:pl-50">
            <div class="flex justify-between my-5"><p :class="isDarkMode? 'text-app-color' : 'text-dark-500'">Ordered list</p>            <p>1.</p></div>
          </div>

          <div class="block md:hidden w-300 md:pl-50">
            <div class="flex justify-between my-5"><p :class="isDarkMode? 'text-app-color' : 'text-dark-500'">Divider</p>                 <p>---</p></div>
            <div class="flex justify-between my-5"><p :class="isDarkMode? 'text-app-color' : 'text-dark-500'">H1</p>                      <p>#</p></div>
            <div class="flex justify-between my-5"><p :class="isDarkMode? 'text-app-color' : 'text-dark-500'">H2</p>                      <p>##</p></div>
            <div class="flex justify-between my-5"><p :class="isDarkMode? 'text-app-color' : 'text-dark-500'">H3</p>                      <p>###</p></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'KeyboardShortcuts',

  emits: ['back'],

  computed: {
    ...mapGetters(['isDarkMode'])
  },

  methods: {
    back () {
      this.$emit('back')
    }
  }
}
</script>
